<template>
  <div v-if="menu && !pagesLoading">
    <page-header :header="menu.name">
      <div class="flex items-center">
        <button
          class="mr-3 focus:outline-none"
          @click="viewMode = 'gallery'"
          :class="[viewMode === 'gallery' ? 'text-grey-darker' : 'text-grey hover:text-grey-dark']"
        >
          <icon
            name="gallery_view"
            class="w-8 h-8"
            :center="false"
          />
        </button>

        <button
          class="mr-3 focus:outline-none"
          @click="viewMode = 'list'"
          :class="[viewMode === 'list' ? 'text-grey-darker' : 'text-grey hover:text-grey-dark']"
        >
          <icon
            name="list_view"
            class="w-8 h-8"
            :center="false"
          />
        </button>
      </div>
    </page-header>
    <transition-group
      name="list"
      tag="div"
      v-if="menuPages.length > 0"
      class="flex -mx-6 -mt-6"
      :class="{
        'flex-wrap': viewMode === 'gallery',
        'flex-col': viewMode === 'list'
      }"
    >
      <div
        v-for="(page, index) in menuPages"
        :key="page.id"
        class="w-full mt-4"
        :class="{
          'md:w-1/2 xl:w-1/3': viewMode === 'gallery',
        }"
      >
        <div
          class="flex flex-col bg-white rounded-lg mb-2 mx-6 mt-10 p-4 md:p-6 cursor-pointer"
          :class="{
            'h-80': viewMode === 'gallery',
          }"
          @click="$router.push(`${menu.slug}/${page.slug}`)"
        >
          <div
            class="flex-no-shrink flex justify-between mb-2 md:mb-4 border-b"
            :class="{
              'pb-4': viewMode === 'gallery'
            }"
          >
            <div class="flex">
              <div
                class="p-4 rounded-lg relative flex-no-shrink text-white"
                :class="[{
                  'w-24 h-24 -mt-12': viewMode === 'gallery',
                  'w-16 h-16 -mt-10': viewMode === 'list'
                }, page.icon_color ? page.icon_color : 'bg-tertiary']"
              >
                <!-- <i v-if="page.icon" class="fas fa-5x fa-fw" :class="`fa-${page.icon}`" /> -->
                <!-- <i v-else class="fas fa-file-alt fa-5x fa-fw" /> -->
                <icon v-if="page.icon" :name="page.icon" :class="page.icon_text_color" />
                <icon v-else name="information_circle" class="text-white" />
              </div>
              <span class="ml-4 mb-4 text-xl font-medium w-full">{{ page.title }}</span>
            </div>
            <div v-if="system.external_data.plan === true">
              <div v-if="viewMode === 'gallery' && !page.available_plan.hidePlanIcons">
                <pop-over-content v-if="(selectedOffice.network_id === 2 && returnIcon(page) !='members-hub-tick')" :message="returnIcon(page)" class="flex-no-shrink w-10 h-10 -mt-12">
                  <icon :name="returnIcon(page)" :class="(page.available_plan[selectedOffice.role] === 'Included' ? 'text-green' : '')"/>
                </pop-over-content>
                <div v-else-if="selectedOffice.network_id === 2" class="flex-no-shrink w-10 h-10 -mt-12">
                  <icon :name="returnIcon(page)" :class="(page.available_plan[selectedOffice.role] === 'Included' ? 'text-green' : '')"/>
                </div>
              </div>
            </div>
            <div v-if="viewMode === 'list' && profile && [1, 2].includes(profile.type)">
              <div class="flex items-center">
                <span class="mr-4"># {{ index + 1 }}</span>
                <div class="flex flex-col">
                  <button
                    class="focus:outline-none mb-1 text-grey hover:text-grey-darker"
                    @click.stop="move(index, index - 1)"
                    :class="{
                      'opacity-25': index === 0
                    }"
                  >
                    <i class="fa fa-chevron-up" />
                  </button>

                  <button
                    class="focus:outline-none mb-1 text-grey hover:text-grey-darker"
                    @click.stop="move(index, index + 1)"
                    :class="{
                      'opacity-25': index === menuPages.length - 1
                    }"
                  >
                    <i class="fa fa-chevron-down" />
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div class="mt-2 overflow-x-hidden overflow-y-auto">
            <p class="leading-normal">{{ page.intro }}</p>
          </div>
        </div>
      </div>
    </transition-group>
    <div v-else  class="w-full flex flex-col md:flex-row items-center">
      <div class="w-full md:w-1/2 text-center">
        <h1 class="text-5xl font-thin mb-6 text-center">
          Urm...
        </h1>
        <h2 class="text-3xl font-normal mb-12">
          Looks like we've not added any pages here yet
        </h2>
        <router-link to="/" class="inline-block no-underline text-black text-1xl font-normal bg-white rounded shadow px-4 py-3 hover:shadow-none">
          Take me home
        </router-link>
      </div>
    </div>
  </div>
  <div v-else-if="notFound && !pagesLoading" class="flex flex-wrap pt-10 -mx-6 -mt-6">
   <div  class="w-full flex flex-col md:flex-row items-center">
    <div class="w-full md:w-1/2 text-center">
      <h1 class="text-5xl font-thin mb-6 text-center">
        Urm...
      </h1>
      <h2 class="text-3xl font-normal mb-12">
        Page not found
      </h2>
      <router-link to="/" class="inline-block no-underline text-black text-1xl font-normal bg-white rounded shadow px-4 py-3 hover:shadow-none">
        Take me home
      </router-link>
    </div>
  </div>
  </div>
  <loader v-else/>

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { find, debounce, map } from 'lodash'
import api from '@/http'
import PopOverContent from '../components/PopOverContent.vue'

export default {
  props: ['menuSlug'],
  components: {
    PopOverContent
  },

  data () {
    return {
      menu: null,
      menuPages: [],
      notFound: false,
      viewMode: 'gallery'
    }
  },

  computed: {
    ...mapGetters(['getMenuPages', 'allMenus']),
    ...mapState(['selectedOffice', 'pages', 'pagesLoading', 'profile', 'system'])
  },

  methods: {
    load () {
      this.menu = find(this.allMenus, m => m.slug === this.menuSlug)
      if (!this.menu) {
        this.notFound = true
        return
      }
      this.menuPages = this.getMenuPages(this.menu)
    },
    move (from, to) {
      if (from < 0 || to >= this.menuPages.length) return
      this.menuPages.splice(to, 0, this.menuPages.splice(from, 1)[0])
      this.saveSortOrder()
    },

    saveSortOrder: debounce(function () {
      api.post('/pages/sort', {
        pages: map(this.menuPages, 'id')
      })
    }, 1000),
    returnIcon (page) {
      var icon = page.available_plan[this.selectedOffice.role]
      if (this.selectedOffice.role === 'Standard' && page.available_plan.Standard === 'Locked' && page.available_plan.Premium === 'Included' && page.available_plan.Enhanced === 'Included') {
        return 'locked-enhanced-premium'
      }
      if (this.selectedOffice.role === 'Legacy' && page.available_plan.Standard === 'Locked' && page.available_plan.Premium === 'Included' && page.available_plan.Enhanced === 'Included') {
        return 'locked-enhanced-premium'
      }
      if (this.selectedOffice.role === 'Legacy' && page.available_plan.Legacy === 'Locked' && page.available_plan.Standard === 'Included' && page.available_plan.Premium === 'Included' && page.available_plan.Enhanced === 'Included') {
        return 'locked-standard-enhanced-premium'
      }
      if (this.selectedOffice.role === 'Standard' && page.product_module === 'App\\Members\\ProductModules\\AutoProspectingModule' && this.selectedOffice.aps_override === true) {
        icon = 'Included'
      }
      switch (icon) {
        case 'Included':
          icon = 'members-hub-tick'
          break
        case 'Discounted':
          icon = 'discount-all'
          break
        case 'Locked':
          icon = 'locked-premium'
          break
        default:
          break
      }
      return icon
    }
  },
  created () {
    this.load()
  },

  watch: {
    '$route' (to, from) {
      this.load()
    },
    allMenus () {
      this.load()
    },
    pages () {
      this.load()
    },
    selectedOffice () {
      this.menuPages = this.getMenuPages(this.menu)
    }
  }
}
</script>

<style scoped>
.list-move {
  transition: transform 1s;
}
</style>
